import { trpc } from '@/lib/trpc';
import { Card, CardContent } from '@/components/ui/Card';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '@/components/ui/Table';

interface SaldosDiariosViewProps {
  eventoId: string;
}

export function SaldosDiariosView({ eventoId }: SaldosDiariosViewProps) {
  const { data: saldos, isLoading } = trpc.livroCaixa.getSaldosDiarios.useQuery({ eventoId });

  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  };

  const formatDate = (date: string) => {
    const [y, m, d] = date.split('-');
    return `${d}/${m}/${y}`;
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-8">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary-600 border-t-transparent" />
      </div>
    );
  }

  return (
    <Card>
      <CardContent className="p-0 overflow-x-auto">
        {saldos && saldos.length > 0 ? (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Data</TableHead>
                <TableHead className="text-right">Receitas</TableHead>
                <TableHead className="text-right">Despesas</TableHead>
                <TableHead className="text-right">Saldo Acumulado</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {saldos.map((s) => (
                <TableRow key={s.data}>
                  <TableCell className="font-medium">{formatDate(s.data)}</TableCell>
                  <TableCell className="text-right text-green-600">
                    {s.receitas > 0 ? formatCurrency(s.receitas) : '-'}
                  </TableCell>
                  <TableCell className="text-right text-red-600">
                    {s.despesas > 0 ? formatCurrency(s.despesas) : '-'}
                  </TableCell>
                  <TableCell className={`text-right font-semibold ${s.saldo >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                    {formatCurrency(s.saldo)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        ) : (
          <div className="py-8 text-center text-gray-500">
            <p>Nenhum lançamento registrado</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
